import React, {useState} from 'react';
import {List, Map} from 'immutable';
import {CallSpeaker} from '@components/call-card/CallSpeaker';
import {PctDouble, Seconds} from '@store/@types/util';
import Button from '@material-ui/core/Button';
import './CallSpeakerFull.sass';
import Divider from '@material-ui/core/Divider';
import {DragStatus, Speaker, SpeakerNumber} from '@store/call-card/CallCard.types';
import IntervalTree from 'node-interval-tree';
import {PlayerProps, PlayerTickGuideId} from '@components/call-card/Player.utils';
import {MatchLocation} from './TranscriptMatch.utils';
import {SetState} from '@store/@types/util/React';

interface CallSpeakerFullProps extends PlayerProps {
  speakers: List<Speaker>;
  talkTime: Map<number, Seconds>;
  segmentTree: IntervalTree<SpeakerNumber, Seconds>;
  speakerTracks: Map<SpeakerNumber, string> | undefined;
  setTimePct: (pct: PctDouble) => void;
  speakerMatches: Map<SpeakerNumber, List<MatchLocation>>;
  dragStatus: DragStatus;
  setDragStatus: SetState<DragStatus>;
}

// Default number of speakers to show
const DEFAULT_COUNT = 4;

export const CallSpeakerFull: React.FC<CallSpeakerFullProps> = ({
  speakers,
  talkTime,
  segmentTree,
  speakerTracks,
  setTimePct,
  speakerMatches,
  dragStatus,
  setDragStatus,
  ...playerProps
}) => {
  const [speakerCount, setSpeakerCount] = useState(DEFAULT_COUNT);
  const renderSpeakers = speakers.take(speakerCount);

  return (
    <div className="call-speaker-full">
      {/* No idea why this thing wants to be dragged, but don't let it */}
      <div className="speaker-list" onDragStart={e => e.preventDefault()}>
        {renderSpeakers.map(s => (
          <CallSpeaker
            key={s.speakerNumber}
            speaker={s}
            talkTime={talkTime.get(s.speakerNumber) ?? 0}
            speakerTrack={speakerTracks?.get(s.speakerNumber)}
            speakerTree={segmentTree}
            setTimePct={setTimePct}
            matchLocations={speakerMatches.get(s.speakerNumber, List())}
            hideInfo={false}
            setDragStatus={setDragStatus}
            dragStatus={dragStatus}
            {...playerProps}
          />
        ))}
      </div>
      <Divider id={PlayerTickGuideId} />
      {speakers.size > 2 && (
        <Button
          onClick={() =>
            setSpeakerCount(speakerCount === DEFAULT_COUNT ? speakers.size : DEFAULT_COUNT)
          }
          className="show-hide-speakers">
          Show/Hide Speakers ({renderSpeakers.size}/{speakers.size})
        </Button>
      )}
    </div>
  );
};
